<template>
    <!--    <div>-->
    <!--        <nav class="navbar navbar-expand-lg navbar-light">-->
    <!--            <div class="ml-auto">-->
    <!--                <form class="form-inline my-2 my-lg-0 col-form-label">-->
    <!--                    <label class="col-form-label">เลือกช่วงวัน</label>-->
    <!--                    &nbsp; &nbsp;-->
    <!--                    <date-picker-->
    <!--                            v-model="search.start_date"-->
    <!--                            type="date"-->
    <!--                            :format="changeFormat"-->
    <!--                            :lang="lang"-->
    <!--                            :not-after="currentDate"-->
    <!--                            placeholder="วันที่เริ่มต้น" >-->
    <!--                    </date-picker>-->
    <!--                    &nbsp;-->
    <!--                    <date-picker-->
    <!--                            v-model="search.end_date"-->
    <!--                            type="date"-->
    <!--                            :format="changeFormat"-->
    <!--                            :lang="lang"-->
    <!--                            :not-before="search.start_date"-->
    <!--                            :not-after="currentDate"-->
    <!--                            placeholder="วันที่สิ้นสุด" >-->
    <!--                    </date-picker>-->
    <!--                    &nbsp;-->
    <!--                    &nbsp; &nbsp; &nbsp;-->
    <!--                    <label class="col-form-label">เลือกเซลล์</label>-->
    <!--                    &nbsp;&nbsp;-->
    <!--                    <div >-->
    <!--                        <multiselect-->
    <!--                                v-model="search.sellers_name"-->
    <!--                                :options="OptionSeller"-->
    <!--                                :customLabel="customLabel"-->
    <!--                                :multiple="true"-->
    <!--                                :show-labels="false"-->
    <!--                                track-by="sale_id"-->
    <!--                                placeholder="กรุณาเลือกเซลล์">-->
    <!--                        </multiselect>-->
    <!--                    </div>-->
    <!--                    &nbsp; &nbsp; &nbsp;-->
    <!--                    <label class="col-form-label">เลือกหัวข้อที่ต้องการ</label>-->
    <!--                    &nbsp;&nbsp;-->
    <!--                    <div class="w-20">-->
    <!--                        <multiselect-->
    <!--                                v-model="search.topics"-->
    <!--                                     :options="optionsType"-->
    <!--                                     :customLabel="customLabelType"-->
    <!--                                     :multiple="true"-->
    <!--                                     :show-labels="false"-->
    <!--                                     track-by="name"-->
    <!--                                     placeholder="เลือกหัวข้อ">-->
    <!--                        </multiselect>-->
    <!--                    </div>-->

    <!--                    &nbsp; &nbsp;-->
    <!--                    <button-->
    <!--                            @click="searchTest"-->
    <!--                            class="btn btn-success my-2 my-sm-0"-->
    <!--                            type="button">-->
    <!--                        <icon name="search"></icon> ค้นหา-->
    <!--                    </button>-->
    <!--                    &nbsp;&nbsp;-->
    <!--                    <button class="btn btn-primary my-2 my-sm-0" type="button">-->
    <!--                        <icon name="download"></icon> Export-->
    <!--                    </button>&nbsp;-->

    <!--                </form>-->
    <!--            </div>-->
    <!--        </nav>-->

    <!--        <div class="table-responsive">-->
    <!--            <table class="table table-bordered text-center">-->
    <!--                <thead>-->
    <!--                <tr>-->
    <!--                    <th rowspan="2">เซลล์</th>-->
    <!--                    <template v-if="topics_select == 0 || topics_select == 1 ||topics_select == 4 || topics_select == 5 || topics_select == 7 || topics_select == 8">-->
    <!--                        <th colspan="6">ยอดขาย</th>-->
    <!--                    </template>-->
    <!--                    <template v-if="topics_select == 0 ||  topics_select == 2 || topics_select == 4 || topics_select == 6 || topics_select == 7 || topics_select == 8">-->
    <!--                        <th colspan="6">จำนวนขาย</th>-->
    <!--                    </template>-->
    <!--                    <template  v-if="topics_select == 0 || topics_select == 3 || topics_select == 5 || topics_select == 6 || topics_select == 7 || topics_select == 8">-->
    <!--                        <th colspan="6">หักคืน</th>-->
    <!--                    </template>-->
    <!--                </tr>-->
    <!--                <tr>-->

    <!--                    <template v-if="topics_select == 0 || topics_select == 1 ||topics_select == 4 || topics_select == 5 || topics_select == 7 || topics_select == 8">-->
    <!--                        <th>โฟม</th>-->
    <!--                        <th>แก้ว</th>-->
    <!--                        <th>ช้อน</th>-->
    <!--                        <th>หลอด</th>-->
    <!--                        <th>เบ็ดเตล็ด</th>-->
    <!--                        <th>รวม</th>-->
    <!--                    </template>-->
    <!--                    <template v-if="topics_select == 0 ||  topics_select == 2 || topics_select == 4 || topics_select == 6 || topics_select == 7 || topics_select == 8">-->
    <!--                        <th>โฟม</th>-->
    <!--                        <th>แก้ว</th>-->
    <!--                        <th>ช้อน</th>-->
    <!--                        <th>หลอด</th>-->
    <!--                        <th>เบ็ดเตล็ด</th>-->
    <!--                        <th>รวม</th>-->
    <!--                    </template>-->

    <!--                    <template  v-if="topics_select == 0 || topics_select == 3 || topics_select == 5 || topics_select == 6 || topics_select == 7 || topics_select == 8">-->
    <!--                        <th>โฟม</th>-->
    <!--                        <th>แก้ว</th>-->
    <!--                        <th>ช้อน</th>-->
    <!--                        <th>หลอด</th>-->
    <!--                        <th>เบ็ดเตล็ด</th>-->
    <!--                        <th>รวม</th>-->
    <!--                    </template>-->
    <!--                </tr>-->
    <!--                </thead>-->
    <!--                <tbody>-->

    <!--                <tr v-for="data in sale_group_seller['summary_detail']" >-->

    <!--                        <template v-for="(item, key,index) in data">-->
    <!--                            <td  v-if="index == 0">-->
    <!--                                <template v-if="key == 'summary_name'">-->
    <!--                                    <span> {{item.sale_name}}</span>-->
    <!--                                </template>-->
    <!--                            </td>-->
    <!--                        </template>-->

    <!--                        <template v-if="topics_select == 0 || topics_select == 1 || topics_select == 4 || topics_select == 5 || topics_select == 7 || topics_select == 8"-->
    <!--                            v-for="(item, key,index) in data">-->
    <!--                            <td  v-if="index >= 1" >-->
    <!--                                <template v-if="key != 'summary_name'" >-->
    <!--                                    <template >-->

    <!--                                        <span v-if="item.product_type_id == 1">{{item.total  | currency}}</span>-->
    <!--                                        <span v-else-if="item.product_type_id == 2">{{item.total | currency}} </span>-->
    <!--                                        <span v-else-if="item.product_type_id == 3">{{item.total  | currency}}</span>-->
    <!--                                        <span v-else-if="item.product_type_id == 4">{{item.total  | currency}}</span>-->
    <!--                                        <span v-else>{{item.total  | currency}}</span>-->
    <!--                                    </template>-->
    <!--                                </template>-->

    <!--                            </td>-->
    <!--                        </template>-->


    <!--                        <template v-if="topics_select == 0 || topics_select == 2 || topics_select == 4 || topics_select == 6 || topics_select == 7 || topics_select == 8"-->
    <!--                                v-for="(item, key,index) in data">-->
    <!--                            <td v-if="index >= 1">-->
    <!--                                <template v-if="key != 'summary_name' " >-->
    <!--                                    <template >-->
    <!--                                        <span v-if="item.product_type_id == 1">{{item.quantity }}</span>-->
    <!--                                        <span v-else-if="item.product_type_id == 2">{{item.quantity}} </span>-->
    <!--                                        <span v-else-if="item.product_type_id == 3">{{item.quantity  }}</span>-->
    <!--                                        <span v-else-if="item.product_type_id == 4">{{item.quantity }}</span>-->
    <!--                                        <span v-else-if="item.total == null">0</span>-->
    <!--                                        <span v-else>{{item.quantity }}</span>-->
    <!--                                    </template>-->
    <!--                                </template>-->
    <!--                            </td>-->
    <!--                        </template>-->

    <!--                        <template v-if="topics_select == 0 || topics_select == 3 || topics_select == 5 || topics_select == 6 || topics_select == 7 || topics_select == 8"-->
    <!--                                v-for="(item, key,index) in data">-->
    <!--                            <td v-if="index >= 1">-->
    <!--                                <template v-if="key != 'summary_name'" >-->
    <!--                                    <template>-->
    <!--                                        <span v-if="item.product_type_id == 1">{{item.total_price_return  | currency}}</span>-->
    <!--                                        <span v-else-if="item.product_type_id == 2">{{item.total_price_return | currency}} </span>-->
    <!--                                        <span v-else-if="item.product_type_id == 3">{{item.total_price_return  | currency}}</span>-->
    <!--                                        <span v-else-if="item.product_type_id == 4">{{item.total_price_return  | currency}}</span>-->
    <!--                                        <span v-else-if="item.total_price_return == null">0.00</span>-->
    <!--                                        <span v-else>{{item.total_price_return  | currency}}</span>-->
    <!--                                    </template>-->
    <!--                                </template>-->
    <!--                            </td>-->
    <!--                        </template>-->

    <!--                </tr>-->
    <!--                </tbody>-->
    <!--            </table>-->
    <!--        </div>-->
    <!--        <b-modal hide-footer hide-header ref="loading">-->
    <!--            <loading @submit="hideLoadingModal" :msg="msg" :status="status_loading"></loading>-->
    <!--        </b-modal>-->
    <!--        <b-modal hide-header hide-footer ref="loading">-->
    <!--            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal">-->
    <!--            </loading>-->
    <!--        </b-modal>-->
    <!--        <br>-->
    <!--    </div>-->

    <div>
        <div class='tableauPlaceholder' id='viz1616407746393' style='position: relative'>
            <noscript><a href='#'><img alt=' '
                                       src='https://public.tableau.com/static/images/38/38095/SaleByProductType/1_rss.png'
                                       style='border: none'/></a></noscript>
            <object class='tableauViz' style='display:none;'>
                <param name='host_url' value='https://public.tableau.com/'/>
                <param name='embed_code_version' value='3'/>
                <param name='site_root' value=''/>
                <param name='name' value='38095/SaleByProductType'/>
                <param name='tabs' value='no'/>
                <param name='toolbar' value='yes'/>
                <param name='static_image'
                       value='https://public.tableau.com/static/images/38/38095/SaleByProductType/1.png'/>
                <param name='animate_transition' value='yes'/>
                <param name='display_static_image' value='yes'/>
                <param name='display_spinner' value='yes'/>
                <param name='display_overlay' value='yes'/>
                <param name='display_count' value='yes'/>
                <param name='language' value='en'/>
            </object>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker'
import Loading from "../../Utility/Loading";

export default {
    name: "report-group-product",
    components: {
        Loading,
        Multiselect,
        DatePicker
    },

    created() {
        // this.$store.dispatch("Dashboard/clearSearch");
        // this.$store.dispatch("ProductType/get");
        // this.getCurrentDate();
        // this.getSaleGroupBySellerAll();
    },
    data() {
        return {
            // msg : "",
            // status_loading : 1,
            // optionsType: [
            //     { name: 'ยอดขาย', value: 1 },
            //     { name: 'จำนวนขาย', value: 2 },
            //     { name: 'หักคืน', value: 3 },
            // ],
            // currentDate: "",
            // topics_select : 0,
            // event_submit : false,
            // sale_group_seller : [],
            // changeFormat: {
            //     stringify: (date) => {
            //         let date_moment = moment(date).format('YYYY');
            //         const year = parseInt(date_moment) + 543;
            //         //console.log(moment(date).format('DD/MM/'+year));
            //         return date ? moment(date).format('DD/MM/'+year) : null
            //     },
            //     parse: (value) => {
            //         return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
            //     }
            // },
            // lang: {
            //     days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
            //     months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
            //     pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
            //     placeholder: {
            //         date: 'วว/ดด/ปปปป',
            //     }
            // },
        };
    },
    computed: {
        // ...mapState({
        //     OptionSeller: state => {
        //         return state.Seller.data;
        //     },
        //     search:state =>{
        //         return state.Dashboard.sale_by_seller_data_search;
        //     },
        // }),
    },
    mounted() {
        this.initTableau();
    },
    methods: {
        // showLoadingModal(){
        //     this.$refs.loading.show();
        // },
        // hideLoadingModal(){
        //     this.$refs.loading.hide();
        // },
        // getSaleGroupBySellerAll(){
        //     this.$store.dispatch("Dashboard/getSaleGroupBySellerAll").then(data=>{
        //         this.sale_group_seller = data;
        //     });
        // },
        // getCurrentDate(){
        //     this.currentDate = moment().format("YYYY-MM-DD");
        // },
        // customLabel (option) {
        //     return `${option.sale_id} - ${option.name}`
        // },
        // customLabelType (option) {
        //     return `${option.name}`
        // },
        // searchTest(){
        //     //console.log('searchTest');
        //     //console.log(this.search.start_date,this.search.end_date);
        //     if(this.search.start_date == null && this.search.end_date){
        //         alert('กรุณาใส่วันที่เริ่มต้น')
        //     }
        //     else  if(this.search.start_date && this.search.end_date == null){
        //         alert('กรุณาใส่วันที่สิ้นสุด')
        //     }
        //     else{
        //         this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
        //         this.status_loading = 1;
        //         this.showLoadingModal();
        //         if(this.search.start_date && this.search.end_date){
        //             //change date format
        //             this.search.start_date = moment(this.search.start_date).format("YYYY-MM-DD");
        //             this.search.end_date = moment(this.search.end_date).format("YYYY-MM-DD");
        //         }
        //         else{
        //             this.search.start_date = "";
        //             this.search.end_date = "";
        //         }
        //         let topics_array = [];
        //         if(this.search.topics.length > 0){
        //             this.search.topics.forEach(topic=>{
        //                 topics_array.push(topic.value);
        //             });
        //         }
        //
        //         let sellers_array = [];
        //         if(this.search.sellers_name.length > 0){
        //             this.search.sellers_name.forEach(seller=>{
        //                 sellers_array.push(seller.id);
        //             });
        //         }
        //
        //         this.search.flag_search = true;
        //         let search_data = {
        //             topics : topics_array,
        //             sellers_name : sellers_array,
        //             start_date : this.search.start_date,
        //             end_date : this.search.end_date,
        //             flag_search : this.search.flag_search
        //         }
        //         //console.log(search_data);
        //         this.$store.dispatch("Dashboard/SaleGroupBySellerAllSearch",search_data).then(res=>{
        //             this.sale_group_seller = res;
        //             this.search.flag_search = false;
        //             //console.log(search_data.topics);
        //
        //             if(search_data.topics.includes(1) && search_data.topics.includes(2) && search_data.topics.includes(3)){
        //                 //console.log(7);
        //                 this.topics_select = 7;
        //             }
        //             else if(search_data.topics.includes(2) && search_data.topics.includes(3)){
        //                 //console.log(6);
        //                 this.topics_select = 6;
        //             }
        //             else if(search_data.topics.includes(1) && search_data.topics.includes(3)){
        //                 //console.log(5);
        //                 this.topics_select = 5;
        //             }
        //             else if(search_data.topics.includes(1) && search_data.topics.includes(2)){
        //                 //console.log(4);
        //                 this.topics_select = 4;
        //             }
        //             else if(search_data.topics.includes(3)){
        //                 //console.log(3);
        //                 this.topics_select = 3;
        //             }
        //             else if(search_data.topics.includes(2)){
        //                 //console.log(2);
        //                 this.topics_select = 2;
        //             }
        //             else if(search_data.topics.includes(1)){
        //                 //console.log(1);
        //                 this.topics_select = 1;
        //             }
        //             else{
        //                 //console.log(8);
        //                 this.topics_select = 8;
        //             }
        //             this.hideLoadingModal();
        //         }).catch(()=>{
        //             this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
        //             this.status_loading = 3;
        //             this.showLoadingModal();
        //         });
        //     }
        // },
        initTableau() {
            var divElement = document.getElementById('viz1616407746393');
            var vizElement = divElement.getElementsByTagName('object')[0];
            vizElement.style.width = '100%';
            vizElement.style.height = (divElement.offsetWidth * 0.75) + 'px';
            var scriptElement = document.createElement('script');
            scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';
            vizElement.parentNode.insertBefore(scriptElement, vizElement);
        }
    }
}
</script>

<style scoped>

</style>
